import { Component, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { BaseModalComponent } from '../../../models/base-modal-component';
import { Endpoint, HelpIndex } from '../../../models/enums';
import { CellTemplateType, GenericColDef } from '../../../models/grid-context';
import { ProjectStatusInfo } from '../../../models/project-status-info';
import { CommonService } from '../../../services/common/common.service';
import { RestService } from '../../../services/rest/rest.service';
import { GenericGridComponent } from '../../generic-grid/generic-grid.component';

@Component({
    standalone: false,
    selector: 'res-system-status-modal',
    templateUrl: './system-status-modal.component.html',
    styleUrls: ['./system-status-modal.component.scss'],
    encapsulation: ViewEncapsulation.None
})

export class SystemStatusModalComponent extends BaseModalComponent implements OnInit {
    @ViewChild(GenericGridComponent, { static: true }) statusGrid: GenericGridComponent;

    modalAutomationId = 'system-status';
    modalClass = 'system-status-modal';
    modalHelpIndex = HelpIndex.case_level_monitoring_dlg;
    statusList = new Array<ProjectStatusInfo>();
    isBusy: boolean;
    isBusyMessage = 'Loading ...';
    noContextMenu = null;

    columnDefs = new Array<GenericColDef>(
        {
            headerName: 'Component',
            field: 'name',
            automationId: this.modalAutomationId,
            lockVisible: true
        },
        {
            headerName: 'Status',
            field: 'label',
            automationId: this.modalAutomationId,
            cellTemplateType: CellTemplateType.nameIconLabel,
            lockVisible: true
        }
    );

    constructor(
        private modalService: BsModalService,
        private modalRef: BsModalRef,
        private commonService: CommonService,
        private restService: RestService,
    ) {
        super(modalService, modalRef);
    }

    ngOnInit(): void {
        this.loadData();
    }

    loadData(): void {
        if (this.commonService.currentProject) {
            this.isBusy = true;

            this.restService.post(Endpoint.projectManager_getProjectResourceStatus, { handle: this.commonService.currentProject.handle }).then((response) => {
                this.isBusy = false;
                this.statusList = new Array<ProjectStatusInfo>();
                if (response) {
                    if (response.dataAreaStatus) {
                        this.statusList.push(new ProjectStatusInfo({ name: 'Data Locations', status: response.dataAreaStatus }));
                    }
                    if (response.componentStatus) {
                        this.statusList.push(new ProjectStatusInfo({ name: 'Processing Components', status: response.componentStatus }));
                    }
                    if (response.storageStatus) {
                        this.statusList.push(new ProjectStatusInfo({ name: 'Storage Depot', status: response.storageStatus }));
                    }
                    if (this.statusGrid) {
                        this.statusGrid.setData(this.statusList);
                    }
                }
            });
        }
    }
}
